import { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';
import { getCurrentConference } from '../../../base/conference/functions';
import { JitsiConferenceEvents } from '../../../base/lib-jitsi-meet';
import { participantUpdated } from '../../../base/participants/actions';
import { getParticipantById, getParticipantCount } from '../../../base/participants/functions';
import { allCards, parseCard, setCard, subscribe } from '../../store';
import { SI_LISTENING_CSS } from './styles';
const PROPERTY = 'kamo_si';
const RESCAN_MS = 2000;
/**
 * TPENGAGE (owner 2026-10-28): mounted once in the meeting, for everyone (guests too). It reads each SI ear's presence
 * property (hidden participants only: Kamo's recorder account, never a guest) and keeps the cards current, and draws
 * each SI's own picture on its tile (owner bug: the tile showed initials although the SI has a photo or an avatar; the
 * SI joins by phone bridge, which carries no picture). A participant's own avatar setting is never used for an SI.
 *
 * @returns {null}
 */
export default function SiListeningHost() {
    const conference = useSelector((state) => getCurrentConference(state));
    const count = useSelector((state) => getParticipantCount(state));
    const store = useStore();
    useEffect(() => {
        if (!document.getElementById('kamo-si-listening-css')) {
            const style = document.createElement('style');
            style.id = 'kamo-si-listening-css';
            style.textContent = SI_LISTENING_CSS;
            document.head.appendChild(style);
        }
    }, []);
    useEffect(() => {
        if (!conference) {
            return;
        }
        const read = (p) => {
            if (!p || typeof p.getId !== 'function') {
                return;
            }
            const hidden = typeof p.isHidden === 'function' && p.isHidden();
            const card = hidden ? parseCard(p.getProperty?.(PROPERTY)) : null;
            setCard(p.getId(), card);
        };
        const scan = () => {
            for (const p of conference.getParticipants?.() ?? []) {
                read(p);
            }
        };
        const changed = (p, name) => {
            if (name === PROPERTY) {
                read(p);
            }
        };
        const left = (id) => setCard(id, null);
        conference.on(JitsiConferenceEvents.PARTICIPANT_PROPERTY_CHANGED, changed);
        conference.on(JitsiConferenceEvents.USER_LEFT, left);
        scan();
        const timer = setInterval(scan, RESCAN_MS);
        return () => {
            clearInterval(timer);
            conference.off(JitsiConferenceEvents.PARTICIPANT_PROPERTY_CHANGED, changed);
            conference.off(JitsiConferenceEvents.USER_LEFT, left);
        };
    }, [conference]);
    // The SI's picture on its own tile, as soon as its card says which tile it is (and when that tile arrives).
    useEffect(() => {
        const draw = () => {
            for (const card of Object.values(allCards())) {
                const p = getParticipantById(store.getState(), card.si);
                if (p && card.avatarUrl && p.avatarURL !== card.avatarUrl) {
                    store.dispatch(participantUpdated({ conference,
                        id: card.si,
                        avatarURL: card.avatarUrl }));
                }
            }
        };
        draw();
        return subscribe(draw);
    }, [conference, count]);
    return null;
}
